export { default } from './BaseSlider';
